import React, {Fragment, useState} from "react";
import {useFieldArray, useFormContext} from "react-hook-form";
import {renderCommentFields} from "../../../helpers/renderComponents.helpers";
import useIcons from "../../../hooks/useIcons";
import "../requestDetails.scss";
import {iconNames} from "../../../constants/icon-names";

const RequestPhotoAutoInfo = ({
                                  showCommentFields,
                                  comments,
                                  handleCommentChange,
                                  photoType,
                                  name
                              }) => {
    const {getIcon, getIconComponent} = useIcons();
    const [openIndex, setOpenIndex] = useState(null);
    const [imgSrc, setImgSrc] = useState(null);
    const {control} = useFormContext();
    const {fields} = useFieldArray({
        control,
        name: photoType,
        shouldUnregister: true,
    });

    const handleImageClick = (index) => {
        !imgSrc && setOpenIndex(index);
    };

    const handleClose = () => {
        setOpenIndex(null);
    };

    const handleError = () => {
        setImgSrc(getIconComponent(iconNames.NOIMAGE));
    };

    const findCommentById = (id) => {
        const commentArray = photoType === 'files'
            ? comments.registrationDocumentPhotos
            : comments.vehiclePhotos;

        if (!commentArray) return "";
        const found = commentArray.find(item => item.id === id);
        return found ? found.comment : "";
    };

    return (
        <div className="photo-container">
            <div className="photo-grid">
                {fields.map((item, index) => (
                    <Fragment key={item.id}>
                        <div className="card-container">
                            <div onClick={() => handleImageClick(index)}>
                                <div className="image-wrapper">
                                    <img
                                        width={300}
                                        src={imgSrc || item.content}
                                        className="card-image"
                                        onError={handleError}
                                    />
                                </div>
                                {item.comment && <span>Комментарий: {item.comment}</span>}
                            </div>
                            {showCommentFields &&
                                renderCommentFields(
                                    showCommentFields,
                                    item.id,
                                    findCommentById(item.id),
                                    handleCommentChange(
                                        name,
                                        item,
                                        photoType
                                    ),
                                    photoType
                                )}
                        </div>
                        {openIndex === index && (
                            <div className="wrapper-overlay" onClick={handleClose}>
                                <img
                                    className="preview-img"
                                    src={item.content}
                                    onClick={(e) => e.stopPropagation()}
                                />
                                <button className="close-icon" onClick={handleClose}>
                                    <span className="icon">{getIcon(iconNames.CROSS)}</span>
                                </button>
                            </div>
                        )}
                    </Fragment>
                ))}
            </div>
            <div>Загружено {photoType === 'files' ? 'документов' : 'фотографий'}: {fields.length}</div>
        </div>
    );
};

export default RequestPhotoAutoInfo;